<template>
    <v-btn color="primary" @click="promptInstallation" v-bind="$attrs" v-if="show">
        add to homescreen
        <v-icon right>{{platformIcon}}</v-icon>
    </v-btn>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    export default {
        name: "PwaInstallerBtn",
        inheritAttrs: false,

        computed: {
            ...mapGetters("appshell", ["platform", "declinedPWA", "installedPWA"]),
            platformIcon() {
                let platform = this.platform;
                switch (platform.os.family) {
                    case "Android":
                        return "$vuetify.icons.google";

                    case "iOS":
                        return "$vuetify.icons.apple";

                    case "Windows":
                        return "$vuetify.icons.microsoft";

                    default:
                        return "$vuetify.icons.phone";
                }
            }
        },

        data: () => ({
            show: false,
            deferredPrompt: null
        }),


        methods: {
            declineInstallation() {
                this.show = false;
                this.$store.dispatch("appshell/updateDeclinedPWA", true);
            },
            promptInstallation(e) {
                //console.log("pwa-installer.promptInstallation:", e, this.deferredPrompt);
                if (this.deferredPrompt) {
                    // Show the prompt
                    this.deferredPrompt.prompt();
                    // Wait for the user to respond to the prompt
                    this.deferredPrompt.userChoice.then(choice => {
                        console.log(
                            "pwa-installer-btn.promptInstallation.userChoice:",
                            choice.outcome
                        );
                        if (choice.outcome === "accepted") {
                            this.$store.dispatch("appshell/updateInstalledPWA", true);
                        } else {
                            this.$store.dispatch("appshell/updateDeclinedPWA", true);
                        }
                    });
                }

                this.deferredPrompt = null;
                this.show = false;
            }
        },

        mounted() {
            window.addEventListener("beforeinstallprompt", e => {
                // Prevent Chrome 67 and earlier from automatically showing the prompt
                e.preventDefault();
                //console.log("pwa-installer.promptInstallation:", e, this.deferredPrompt);
                // Stash the event so it can be triggered later.
                this.deferredPrompt = e;
                // show installation button:
                if (!this.installedPWA) {
                    this.show = true;
                }
            });
        }
    }
</script>

<style lang="scss" scoped>

</style>